import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { HEADER_DATA_SOURCE } from '../../../externals';
import { useMutation } from '@apollo/client';
import { SET_ONBOARDING_MEGA_MENU_NO_AUTO_OPEN } from './onboardingOperations';
import { logGQLErrors } from '../../../shared/logGQLErrors';
export var useSetOnboardingMegaMenuNoAutoOpen = function useSetOnboardingMegaMenuNoAutoOpen() {
  var _useMutation = useMutation(SET_ONBOARDING_MEGA_MENU_NO_AUTO_OPEN, {
    context: _defineProperty({}, HEADER_DATA_SOURCE, true),
    onError: function onError(error) {
      return logGQLErrors('Header - Set onboarding mega menu no auto open failed', error);
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      setOnboardingMegaMenuNoAutoOpen = _useMutation2[0];

  return setOnboardingMegaMenuNoAutoOpen;
};